/* eslint-disable no-nested-ternary */

import { useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import './styles/styles.css';
import { useLocation, useParams } from 'react-router-dom';
import { useGuestAuth } from '../../modules/hooks';

import { GuestPortalProvider } from '../Providers/GuestPortalV2';
import { Feedback } from './Feedback';
import { GuestPortal } from './GuestPortal';
import { GuestRegistration } from './GuestRegistration';
import GuestPageHeader from './Header';

const GuestPageLayout = () => {
  const { pathname } = useLocation();
  const { reservationId } = useParams();

  const { token, generateAuthToken } = useGuestAuth()!;

  useEffect(() => {
    document.title = 'Guest Portal';
  }, []);

  useEffect(() => {
    if (!reservationId) return;

    if (token) return;

    generateAuthToken({ reservationId });
  }, [reservationId]);

  return (
    <GuestPortalProvider reservationId={reservationId || ''}>
      <Container
        id="guest-portal"
        fluid
        className="page-container"
        style={{ paddingLeft: '0px', paddingRight: '0px' }}
      >
        {token && (
          <Card className="card-item" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
            {pathname.includes('/guest-registration/') ? (
              <>
                <GuestPageHeader type="verify" />
                <GuestRegistration reservationId={reservationId || ''} />
              </>
            ) : pathname.includes('/feedback/') ? (
              <>
                <GuestPageHeader type="firstRegistration" />
                <Feedback />
              </>
            ) : (
              <>
                <GuestPageHeader type="firstRegistration" />
                <GuestPortal />
              </>
            )}
          </Card>
        )}
      </Container>
    </GuestPortalProvider>
  );
};

export default GuestPageLayout;
